var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"export-excel",attrs:{"loading":_vm.isLoading},on:{"click":_vm.clickEmit}},[_vm._v(_vm._s(_vm.btnName))])}
var staticRenderFns = []

export { render, staticRenderFns }